
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/society/reset-password",
      function () {
        return require("private-next-pages/society/reset-password/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/society/reset-password"])
      });
    }
  